import {FirebaseTopicModel} from "../firebase-topic-model";
import {GamblingSessionUpdateData} from "./gambling-session-topic.model.interface";

export class GamblingSessionTopicModel extends FirebaseTopicModel<GamblingSessionUpdateData, GamblingSessionUpdateData> {
    getTopicName(): string {
        return `gamblingSessions/${this.services.user.cid}`
    }

    getTopicLabel(): string {
        return "GamblingSession";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: GamblingSessionUpdateData): GamblingSessionUpdateData {
        return rawMessage;
    }

    protected async _isEnabled(): Promise<boolean> {
        return await super._isEnabled() && Boolean(this.configs.GamblingSession.enabled);
    }
}